import { render, staticRenderFns } from "./TrendCard.vue?vue&type=template&id=740da130&scoped=true"
import script from "./TrendCard.vue?vue&type=script&lang=js"
export * from "./TrendCard.vue?vue&type=script&lang=js"
import style0 from "./TrendCard.vue?vue&type=style&index=0&id=740da130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740da130",
  null
  
)

export default component.exports